/*
 * A composable that provides a global state object for Vue 3 apps.
 *
 * Example:
 * import {useGlobalState, VueDataStateKey} from "@/core/composables/global-state";
 * const globalState = useGlobalState();
 * globalState.set(VueDataStateKey.GlobalStylesInjected, true);
 */
// Types & Enums
export var VueDataStateKey;
(function (VueDataStateKey) {
    VueDataStateKey["GlobalStylesInjected"] = "GlobalStylesInjected";
    VueDataStateKey["ToastNotificationsInitialized"] = "ToastNotificationsInitialized";
})(VueDataStateKey || (VueDataStateKey = {}));
// Helper function
const initializeVueDataStateWithDefaults = () => {
    window.RecollectiveVueData = new Map([
        [VueDataStateKey.GlobalStylesInjected, false],
        [VueDataStateKey.ToastNotificationsInitialized, false]
    ]);
};
// Composable
export const useGlobalState = () => {
    if (!window.RecollectiveVueData)
        initializeVueDataStateWithDefaults();
    const set = (key, value) => window.RecollectiveVueData?.set(key, value);
    const get = (key) => window.RecollectiveVueData?.get(key);
    // Returning the set and get functions prevents from exposing the whole global state map.
    return { set, get };
};
